import React from "react";
import styled from "styled-components";

export default styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    padding-top: 3px;
    @media(max-width: 725px) {
        width: 100%;
        display: block;
    }
`;
